import { ChangeEvent, KeyboardEvent, useCallback, useState } from "react";
import { searchLabelStyle, SearchSpacer } from "src/components/common/common";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { defaultPRD2030_R01Filter, usePRD2030_R01Store } from "./Store_PRD2030_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import useUiuxStore from "src/store/useUiuxStore";
import { EmployeeDto } from "src/types/base";
import { getEmployeeList } from "src/apis/employeeApi";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchSection_PRD2030_R01 = (props: Props) => {

	const { onEnterKeyDown } = props;

    const { setCodeSearchModalProps } = useUiuxStore();
	const { PRD2030_R01Filter, setPRD2030_R01Filter } = usePRD2030_R01Store();
	const { compCdList, workPlaceList, jobTeamList, yesNoList } = useCommonCodeStore();

	
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
	const handleWorkEmpFoucsId = 'workEmp_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'workEmp',
			category: '작업자',
			focusId: handleWorkEmpFoucsId,
			responseMapping: {
				empNo: 'workEmp',
				empNm: 'workEmpNm',
			},
			extraFilter: () => ({
				workEmp: PRD2030_R01Filter.workEmp || '',
				workEmpNm: PRD2030_R01Filter.workEmpNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: PRD2030_R01Filter,
		setEditData: setPRD2030_R01Filter,
		defaultData: defaultPRD2030_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'TQC2020_R01_search'
	});

	return (
		<SearchSectionDoubleForm >
			{/* PRD2020Filter : {JSON.stringify(PRD2030_R01Filter)} <br /> */}
			<SearchDropDownForm
				label="사업장"
				value={PRD2030_R01Filter.compCd}
				onChangeItem={(item) => setPRD2030_R01Filter({ compCd: item?.compCd || ''})}
				optionList={compCdList}
			/>
			<SearchDateRangeForm
					label="생산일자"
					visible={pickerVisible}
					setVisible={setPickerVisible}
					dateRange={PRD2030_R01Filter.dateRange}
					setDateRange={v => setPRD2030_R01Filter({  dateRange: v})}
					pickerPosition={pickerPosition}
					setPickerPosition={setPickerPosition}
				/>
			<SearchDropDownForm
				label="작업공정"
				value={PRD2030_R01Filter.workplaceCd}
				onChangeItem={(item) => setPRD2030_R01Filter({ workplaceCd: item?.workplaceCd || ''})}
				optionList={workPlaceList.filter(opt => opt.compCd === PRD2030_R01Filter.compCd)}
				editable={PRD2030_R01Filter.compCd !== ''}
			/>
			<SearchCodeModalForm
				label="작업자"
				value={PRD2030_R01Filter.workEmp}
				valueLabel={PRD2030_R01Filter.workEmpNm}
				handleFoucsId={handleWorkEmpFoucsId}
				onChange={getFieldHandlers('workEmp').onChange}
				onDoubleClick={getFieldHandlers('workEmp').onDoubleClick}
				onKeyDown={getFieldHandlers('workEmp').onEnterKeyDown}
				wrapperOption={{
					wrapperStyle: "w-[300px] min-w-[300px] mr-[10px]",
					titleStyle: "w-[40px] min-w-[40px] text-left",
					codeInputStyle: "w-[100px] min-w-[100px]",
					nameTagStyle: "w-[150px] min-w-[150px] text-left",
				}}
			/>
		</SearchSectionDoubleForm>
	);
};